/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2f51e2e3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Program Files\\gitee\\new\\insurance-market\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__